import Api from "@/services/api";

export default {
    resetPwd(mail) {
        return Api(false).post("/resetPwd", {"email": mail}).then(res => res.data);
    },
    changePwd(dto) {
        return Api().put("/changePwd", dto).then(res => res.data);
    },
}